import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {Helmet} from 'react-helmet';
import parse from 'html-react-parser';
import {careersPageText as careersPageText_en} from '../libs/en/texts-careers-page-lib';
import {careersPageText as careersPageText_en_ca} from '../libs/en-ca/texts-careers-page-lib';
import {careersPageText as careersPageText_de} from '../libs/de/texts-careers-page-lib';
import {careersPageText as careersPageText_de_ch} from '../libs/de-ch/texts-careers-page-lib';
import {careersPageText as careersPageText_fr} from '../libs/fr/texts-careers-page-lib';
import {careersPageText as careersPageText_fr_fr} from '../libs/fr-fr/texts-careers-page-lib';
import {careersPageText as careersPageText_fr_ca} from '../libs/fr-ca/texts-careers-page-lib';
import {careersPageText as careersPageText_nl} from '../libs/nl/texts-careers-page-lib';
import {careersPageText as careersPageText_it} from '../libs/it/texts-careers-page-lib';
import {careersPageText as careersPageText_it_ch} from '../libs/it-ch/texts-careers-page-lib';
import {careersPageText as careersPageText_cz} from '../libs/cz/texts-careers-page-lib';
import {careersPageText as careersPageText_fi} from '../libs/fi/texts-careers-page-lib';
import {careersPageText as careersPageText_pl} from '../libs/pl/texts-careers-page-lib';
import {careersPageText as careersPageText_se} from '../libs/se/texts-careers-page-lib';
import {careersPageText as careersPageText_no} from '../libs/no/texts-careers-page-lib';
import {careersPageText as careersPageText_dk} from '../libs/dk/texts-careers-page-lib';
import {careersPageText as careersPageText_es} from '../libs/es/texts-careers-page-lib';
import {careersPageText as careersPageText_pt} from '../libs/pt/texts-careers-page-lib';
import {ReactComponent as ApplyArrowIcon} from '../assets/images/arrow-apply-careers.svg';

function getVacancyMetaItems(job) {
    if (!job || !job.meta) return [];
    if (Array.isArray(job.meta)) {
        return job.meta.map(String).map((s) => s.trim()).filter(Boolean);
    }
    return String(job.meta)
        .split(/\s*•\s*|\s*·\s*/)
        .map((s) => s.trim())
        .filter(Boolean);
}

export class Careers extends Component {
    constructor(props) {
        super(props);
        const careersPageText = this.getCareersPageText(props.language);
        const vacancies = careersPageText.vacancies || [];
        this.state = {
            careersPageText,
            openVacancyId: vacancies.length > 0 ? vacancies[0].id : null,
        };
        this.toggleVacancy = this.toggleVacancy.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.language !== this.props.language) {
            const careersPageText = this.getCareersPageText(this.props.language);
            const vacancies = careersPageText.vacancies || [];
            this.setState({
                careersPageText,
                openVacancyId: vacancies.length > 0 ? vacancies[0].id : null,
            });
        }
    }

    getCareersPageText(language) {
        if (language === 'DE') return careersPageText_de;
        if (language === 'DE-CH') return careersPageText_de_ch;
        if (language === 'EN-CA') return careersPageText_en_ca;
        if (language === 'FR-FR') return careersPageText_fr_fr;
        if (language === 'FR') return careersPageText_fr;
        if (language === 'FR-CA') return careersPageText_fr_ca;
        if (language === 'NL') return careersPageText_nl;
        if (language === 'IT') return careersPageText_it;
        if (language === 'IT-CH') return careersPageText_it_ch;
        if (language === 'CZ') return careersPageText_cz;
        if (language === 'FI') return careersPageText_fi;
        if (language === 'PL') return careersPageText_pl;
        if (language === 'SE') return careersPageText_se;
        if (language === 'NO') return careersPageText_no;
        if (language === 'DK') return careersPageText_dk;
        if (language === 'ES') return careersPageText_es;
        if (language === 'PT') return careersPageText_pt;
        return careersPageText_en;
    }

    toggleVacancy(id) {
        this.setState((prev) => ({
            openVacancyId: prev.openVacancyId === id ? null : id,
        }));
    }

    renderVacancyAccordions() {
        const { careersPageText, openVacancyId } = this.state;
        const vacancies = careersPageText.vacancies || [];

        const titleKeyHandler = (id) => (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.toggleVacancy(id);
            }
        };

        if (vacancies.length === 0) {
            const id = 'empty';
            const isOpen = openVacancyId === id;
            return (
                <div className="accordian-col">
                    <div
                        className={`accordian-title${isOpen ? ' active' : ''}`}
                        onClick={() => this.toggleVacancy(id)}
                        onKeyDown={titleKeyHandler(id)}
                        role="button"
                        tabIndex={0}
                        aria-expanded={isOpen}
                    >
                        <h4>{careersPageText.emptyVacancyTitle}</h4>
                    </div>
                    <div className="accordian-content" aria-hidden={!isOpen}>
                        <p className="careers-acc-desc">{careersPageText.emptyVacancyBody}</p>
                    </div>
                </div>
            );
        }

        return vacancies.map((job) => {
            const isOpen = openVacancyId === job.id;
            const metaItems = getVacancyMetaItems(job);
            return (
                <div className="accordian-col" key={job.id}>
                    <div
                        className={`accordian-title${isOpen ? ' active' : ''}`}
                        onClick={() => this.toggleVacancy(job.id)}
                        onKeyDown={titleKeyHandler(job.id)}
                        role="button"
                        tabIndex={0}
                        aria-expanded={isOpen}
                    >
                        <h4>{job.title}</h4>
                    </div>
                    <div className="accordian-content" aria-hidden={!isOpen}>
                        <p className="careers-acc-desc">{job.description}</p>
                        {metaItems.length > 0 && (
                            <ul className="careers-acc-meta-list">
                                {metaItems.map((item, idx) => (
                                    <React.Fragment key={idx}>
                                        <li className="careers-acc-meta-item">{item}</li>
                                        {idx < metaItems.length - 1 && (
                                            <li className="careers-acc-meta-sep" aria-hidden="true">•</li>
                                        )}
                                    </React.Fragment>
                                ))}
                            </ul>
                        )}
                        {job.applyUrl && (
                            <a
                                href={job.applyUrl}
                                className="careers-acc-apply"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className="careers-acc-apply-label">{careersPageText.applyLabel}</span>
                                <ApplyArrowIcon
                                    className="careers-acc-apply-icon"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                            </a>
                        )}
                    </div>
                </div>
            );
        });
    }

    render() {
        const { careersPageText } = this.state;
        const benefits = careersPageText.benefits || [];
        const hasJobListings = (careersPageText.vacancies || []).length > 0;

        return (
            <div className="careers-page">
                <Header props={this.props}/>
                <Helmet>
                    <title>{careersPageText.title}</title>
                    <meta name="title" content={careersPageText.titleMeta}/>
                    <meta name="description" content={careersPageText.descriptionMeta}/>
                    <meta name="keywords" content={careersPageText.keywords}/>
                    <meta property="og:locale" content={careersPageText.localeMeta}/>
                </Helmet>

                <section className="careers-hero">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 careers-hero-inner">
                                <h1 className="careers-hero-title">{careersPageText.bannerTitle}</h1>
                                <p className="careers-hero-subtitle">{careersPageText.bannerSubtitle}</p>
                                {hasJobListings && (
                                    <p className="careers-hero-note">{careersPageText.heroNote}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="careers-main">
                    <div className="container">
                        <div className="row careers-two-col">
                            <div className="col-12 col-lg-5 careers-col-left">
                                <p className="careers-intro">{careersPageText.introBody}</p>
                                {careersPageText.benefitsTitle && (
                                    <h2 className="careers-benefits-heading">{careersPageText.benefitsTitle}</h2>
                                )}
                                <ul className="careers-benefits-list">
                                    {benefits.map((line, i) => (
                                        <li key={i}>{line}</li>
                                    ))}
                                </ul>
                                <div className="careers-outro">{parse(careersPageText.outroHtml)}</div>
                            </div>
                            <div className="col-12 col-lg-7 careers-col-right">
                                <div className="careers-acc-wrap">
                                    {this.renderVacancyAccordions()}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer props={this.props}/>
            </div>
        );
    }
}
